import ShoppingListsList from './ShoppingListsList';

export default ShoppingListsList;
